<template>
  <div class="vbox">
    <header class="bg-white-only header header-md navbar navbar-fixed-top-xs">
      <div class="navbar-header aside bg-info dk">      
        <a href="#" class="navbar-brand text-lt" v-on:click="showDashboard()">
          <!-- <i class="icon-earphones"></i> -->
          <span class="hidden-nav-xs m-l-sm">金凤细雨</span>
        </a>
      </div>
      <ul class="nav navbar-nav hidden-xs" v-on:click="MxSider()">
        <li>
          <a href="#nav,.navbar-header" data-toggle="class:nav-xs,nav-xs" class="text-muted" v-bind:class="{ 'active': navxs }">
            <i class="fa fa-indent text"></i>
            <i class="fa fa-dedent text-active"></i>
          </a>
        </li>
      </ul>
      <div class="navbar-left ">
        <ul class="nav navbar-nav m-n hidden-xs nav-user user">        
          <li class="dropdown" v-for="(item,i) in menus" :key="i">
            <a href="#" v-on:click="ChangeSideNav(item.id)" class="dropdown-toggle bg clear" data-toggle="dropdown">
               {{item.name}}
             </a>
          </li>
        </ul>
      </div>
      <HeaderRight></HeaderRight>
    </header>
    <section>
      <section class="hbox stretch">
        <aside class="bg-black dk aside hidden-print" id="nav" v-bind:class="{ 'nav-xs': navxs }">
          <section class="vbox">
            <section class="w-f-md scrollable">
              <div class="slim-scroll"  data-height="auto" data-disable-fade-out="true" data-distance="0" data-size="10px" data-railOpacity="0.2">
                <nav class="nav-primary hidden-xs " v-if="activeMenu" >
                  <ul class="nav" v-for="(item,i) in activeMenu.permissions" :key="i" data-ride="collapse">
                    <li class="hidden-nav-xs padder m-t m-b-sm text-xs text-muted">
                      <span class="pull-right"><a href="#"><i :class=" item.icon"></i></a></span>
                      {{item.name}}
                    </li>
                    <li v-for="(child,i) in item.permissions" :key="i" v-if="!child.permissions" >
                      <a href="#" @click="ChangRouter(child.router)">
                        <i :class="child.icon"></i>
                        <span>{{child.name}}</span>
                      </a>
                    </li>
                    <li v-for="(child,i) in item.permissions" :key="i" v-if="child.permissions" v-bind:class="{ 'active': secondActiceNav==child.id }" v-on:click="ChangeSecondSideNav(child.id)">
                      <a href="#" class="auto" >
                        <span class="pull-right text-muted">
                          <i class="fa fa-angle-left text"></i>
                          <i class="fa fa-angle-down text-active"></i>
                        </span>
                        <i :class="child.icon">
                        </i>
                        <span>{{child.name}}</span>
                      </a> 
                      <ul class="nav dk text-sm" >
                        <li v-for="(secoredChild,i) in child.permissions" :key="i">
                          <a href="#" @click="ChangRouter(secoredChild.router,$event)">
                            <span style="padding-left:33px">{{secoredChild.name}}</span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </section>
            <!-- <footer class="footer hidden-xs no-padder text-center-nav-xs">
              <div class="bg hidden-xs ">
                <div class="dropdown dropup wrapper-sm clearfix">
                  <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                    <span class="thumb-sm avatar pull-left m-l-xs">
                      <img src="http://wx.qlogo.cn/mmopen/0Yice1NbdRsMXQLAel3CiaP6ylibEShiaWB8hmW6zFR9vDxgHzib1KMhy8vmVJhSBrAl32UcoQZy0NcBhBKXGfeSzQIJUmuUI9abH/0" class="dker" alt="...">
                      <i class="on b-black"></i>
                    </span>
                    <span class="hidden-nav-xs clear">
                      <span class="block m-l" style="word-break:keep-all;overflow:hidden;white-space:nowrap;">
                        <strong class="font-bold text-lt">管理员</strong>
                        <b class="caret"></b>
                      </span>
                      <span class="text-muted text-xs block m-l">陈工</span>
                    </span>
                  </a>
                  <ul class="dropdown-menu animated fadeInRight aside text-left">
                    <li>
                      <a href="/SystemManage/User/EditPwd" data-ajax="true" data-ajax-method="Get" data-ajax-mode="Replace">修改密码</a>
                    </li>
                    <li>
                      <a href="/SystemManage/User/CheckPwd" data-ajax="true">安全锁屏</a>
                    </li>
                    <li class="divider"></li>
                    <li>
                      <a href="#" data-toggle="ajaxModal">退出</a>
                    </li>
                  </ul>
                </div>
              </div>
            </footer> -->
          </section>
        </aside>
        <section id="content">
          <router-view :key="key"/>
        </section>
      </section>
    </section>    
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderRight from '@/components/GlobalHeader/index'
export default {
  name: 'Home',
  data (){
    return {
      acticeNav:"store",
      navxs:false,
      secondActiceNav:'',
      menus:[]
    }
  },
  components: {
    HeaderRight
  },
  computed:{
    key(){
      return this.$route.path + Math.random();
    },
    activeMenu:function(){
      var that= this
      var activeMenu = that.menus.find(item=>{return item.id == that.acticeNav})
      return activeMenu
    }
	},
  mounted:function(){
    this.menus = JSON.parse(sessionStorage.getItem('menus'))
    this.showDashboard()
  },
  methods:{
    ChangeSideNav:function(nav){
      this.acticeNav = nav
    },
    ChangeSecondSideNav:function(nav){
      if(this.secondActiceNav == nav)
        this.secondActiceNav = ''
      else 
        this.secondActiceNav =nav
    },
    ChangRouter:function(path,event){
      if(event) {
        event.stopPropagation ? event.stopPropagation(): event.cancelBubble = true;
      }
      let num = Math.floor(Math.random()*1000 + 1);
      this.$router.push(path+"?"+num)
    },
    MxSider:function(){
      this.navxs = !this.navxs     
    },    
    showDashboard(){
      this.$router.push("dashboard")
    }
  }
}
</script>
<style lang='stylus' rel='stylesheet/stylus'>
@import '../assets/css/app.css'
@import '../assets/css/font-awesome.min.css'
@import '../assets/css/simple-line-icons.css'
#content
  background-color #fff
.el-dropdown
  margin-right 90px
.user
  margin-top 10px
  color #fff
</style>